import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import "./mailto.js"

// Stimulus
import { Application } from "@hotwired/stimulus"
import HeroGridController from "./controllers/hero_grid_controller.js"

const application = Application.start()
application.register("hero-grid", HeroGridController)

console.info("Bridgetown is loaded!")
